@if (show) {

    <!-- height needs to be absolute number. calcultate
            overlay height: 90vh
        -   overlay header: 80px
        -   overlay bottom padding: 1.25rem
    -->

    <div [style.height]="height"
        leaflet
        [leafletOptions]="options"
        [leafletLayers]="layers"
        [attr.data-testid]="'map'">
    </div>
}
